














































import Vue, { PropType } from 'vue';
import { BButton } from 'bootstrap-vue';
import { Variable, Operator, Function, FormulaBlockType } from '../types';

export default Vue.extend({
  name: 'Formula',
  components: {
    BButton,
  },
  props: {
    value: {
      type: String,
      default: '',
    },
    textFormula: {
      type: String,
      default: '',
    },
    blocks: {
      type: Array as PropType<Array<Variable | Operator | Function>>,
      default: () => [],
    },
    selectedBlockIndex: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      newFormula: <boolean>true,
      FormulaBlockType: <FormulaBlockType>FormulaBlockType,
    };
  },
  computed: {
    isNewFormula() {
      return this.newFormula || !this.textFormula;
    },
  },
  watch: {
    blocks() {
      this.newFormula = true;
    },
  },
  created() {
    if (this.value) {
      this.newFormula = false;
    }
  },
  methods: {
    formulaBlockClasses(block: Variable | Operator | Function) {
      return [
        'formula-block',
        `${block.type.toLowerCase()}`,
        ...(block.variableType ? [`${block.variableType.toLowerCase()}`] : []),
      ];
    },
    createNewFormula() {
      this.newFormula = true;
      this.$emit('update', '');
    },
    selectBlock(blockIndex: number) {
      this.$emit('select', blockIndex);
    },
    unselectBlock(blockIndex: number) {
      this.$emit('unselect', blockIndex);
    },
    isBlockSelected(blockIndex: number) {
      return this.selectedBlockIndex === blockIndex;
    },
  },
});
